import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IPortfolio = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="17"
            viewBox="0 0 18 17"
            fill={props.color ?? '#37474F'}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.8 3.57895V1.78947H7.2V3.57895H10.8ZM1.8 5.36842V15.2105H16.2V5.36842H1.8ZM16.2 3.57895C17.199 3.57895 18 4.37526 18 5.36842V15.2105C18 16.2037 17.199 17 16.2 17H1.8C0.801 17 0 16.2037 0 15.2105L0.00899999 5.36842C0.00899999 4.37526 0.801 3.57895 1.8 3.57895H5.4V1.78947C5.4 0.796316 6.201 0 7.2 0H10.8C11.799 0 12.6 0.796316 12.6 1.78947V3.57895H16.2Z"
              fill={props.color ?? '#37474F'}
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IPortfolio;
